import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { authClient, legalClient } from "./defaults";
import styles from '../app.module.css';

const UserAgreement = ({ authUser }) => {
    const navigate = useNavigate();
    const [eula, setEula] = useState({ content: "", version: "" });
    const [eulaLoading, setEulaLoading] = useState(true);
    const [eulaError, setEulaError] = useState(null);

    useEffect(() => {
        const fetchEula = async () => {
            try {
                const response = await legalClient.get('/eula');
                const data = response.data;

                if (!data?.eula?.content || !data?.eula?.version) {
                    throw new Error("EULA response is missing required fields.");
                }

                setEula({ content: data.eula.content, version: data.eula.version });

            } catch (error) {
                console.error("Error fetching EULA:", error.response?.data || error);
                setEulaError("Failed to load the agreement. Please try again later.");
            } finally {
                setEulaLoading(false);
            }
        };
        fetchEula();
    }, []);

    const handleAgree = async () => {
        try {
            const [legalResult, authResult] = await Promise.allSettled([
                legalClient.post('/consent', {
                    consentVersion: eula.version,
                    content: eula.content
                }),
                authClient.put('/consent', {
                    consentVersion: eula.version
                })
            ]);

            if (legalResult.status === "fulfilled" || authResult.status === "fulfilled") {
                navigate('/dashboard');
            } else {
                console.error("Error saving consent");
            }

        } catch (error) {
            console.error("Error saving consent:", error.message);
        }
    };

    const handleDisagree = () => {
        navigate('/login-signup');
    };

    if (eulaLoading) {
        return <p>Loading...</p>;
    }

    return (
        <div className={styles.agreementContainer}>
            <h2>User Agreement</h2>
            <p>Please review and accept the agreement to proceed.</p>

            <div className={styles.agreementContent}>
                {eulaError ? (
                    <p className={styles.errorText}>{eulaError}</p>
                ) : (
                    <ReactMarkdown>{eula.content}</ReactMarkdown>
                )}
            </div>

            <div className={styles.buttonContainer}>
                <button onClick={handleAgree} className={styles.agreeButton} disabled={!!eulaError}>
                    I Agree
                </button>
                <button onClick={handleDisagree} className={styles.disagreeButton}>
                    I Disagree
                </button>
            </div>
        </div>
    );
};

export default UserAgreement;
